import $ from 'jquery';

import '../stylesheets/catalog.scss'

$(document).ready(() => {
  if (window.exempt) {
    return;
  }
  Array.from(document.querySelectorAll("a")).forEach((link) => {
    if (!link.classList.contains('targa')) {
      link.removeAttribute('href');
    }
  });
});
